import { FC } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { OwnerDropdown, OwnerDropdownProps } from '../../UI';
import { BusinessFormValues } from '..';

interface BusinessOwnerDropdownProps
  extends Pick<OwnerDropdownProps, 'dropdownMenuClassName' | 'className' | 'popperJSFlipModifierOptions'> {
  firmID: string;
  clientID: string;
}

export const BusinessOwnerDropdown: FC<BusinessOwnerDropdownProps> = (dropdownProps) => {
  const { t: tForm } = useTranslation('form');
  const { control } = useFormContext<BusinessFormValues>();
  const {
    field,
    fieldState: { error },
  } = useController<BusinessFormValues, 'ownerData'>({
    control,
    name: 'ownerData',
    rules: { required: true },
  });

  return (
    <OwnerDropdown
      {...field}
      {...dropdownProps}
      value={field.value?.ownerID}
      status={error ? 'errored' : 'normal'}
      onChange={(data) => field.onChange(data)}
      label={tForm('general-owned-by-dropdown-label')}
      placeholder={tForm('general-required-placeholder')}
    />
  );
};
